import { render, staticRenderFns } from "./officialCodes.vue?vue&type=template&id=5dca9b02&scoped=true&"
import script from "./officialCodes.vue?vue&type=script&lang=js&"
export * from "./officialCodes.vue?vue&type=script&lang=js&"
import style0 from "./officialCodes.vue?vue&type=style&index=0&id=5dca9b02&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca9b02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dca9b02')) {
      api.createRecord('5dca9b02', component.options)
    } else {
      api.reload('5dca9b02', component.options)
    }
    module.hot.accept("./officialCodes.vue?vue&type=template&id=5dca9b02&scoped=true&", function () {
      api.rerender('5dca9b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/officialCodes/officialCodes.vue"
export default component.exports